/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import gql from 'graphql-tag';
import { propType } from 'graphql-anywhere';
// import moment from 'moment-timezone';
import MaskedInput from 'react-text-mask';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  ButtonToolbar,
  ControlLabel,
  Col,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';

import createAutoCorrectedDatePipe from '../../utils/createAutoCorrectedDatePipe';
import EquipmentInput from '../EquipmentInput';
import TicketInput from '../TicketInput';
import { PTO_TYPES } from '../../features/forms/TimeEntry/components/TimeEntryFormComponents';

import '../App.css';

class TimeEntryEditor extends Component {
  static defaultState() {
    return {
      key: null,
      pto_type: 'none',
      equipment: null,
      ticket_number: null,
      start_time: '',
      end_time: '',
      notes: '',
      ptoOpen: false,
    };
  }

  constructor(props) {
    super(props);

    this.state = this.getStateFromProps(this.props);
    this.handlePTOOnFocus = this.handlePTOOnFocus.bind(this);
    this.handlePTOOnToggle = this.handlePTOOnToggle.bind(this);
    this.startKey = 0;
    this.endKey = 0;

    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.handlePTOChange = this.handlePTOChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
  }

  getStateFromProps(props) {
    // FIXME: item === null comparison is insufficient for defaulting form state
    const { item } = props;
    if (item === null) {
      return TimeEntryEditor.defaultState();
    }
    return item;
  }

  handleCreate() {
    // FIXME: Date should really be set on a submission item, rather than on this mutation
    const { date } = this.props;
    const item = { ...this.state, date };
    this.startKey += 1;
    this.endKey += 1;
    this.props.onCreate(item);
  }

  handleUpdate() {
    // FIXME: Date should really be set on a submission item, rather than on this mutation
    const { date } = this.props;
    const item = { ...this.state, date };
    this.startKey += 1;
    this.endKey += 1;
    this.props.onUpdate(item);
  }

  handleCancel() {
    this.startKey += 1;
    this.endKey += 1;
    this.props.onCancel();
  }

  handlePTOChange(e) {
    this.setState({
      pto_type: e,
    });
  }

  handleValueChange(e) {
    const { target: { name, value } } = e;
    this.setState({
      [name]: value,
    });
  }

  handlePTOOnFocus() {
    this.setState({
      ptoOpen: true,
    });
  }

  handlePTOOnToggle(ptoOpen) {
    this.setState({
      ptoOpen,
    });
  }

  render() {
    const {
      key,
      pto_type,
      equipment,
      ticket_number,
      start_time,
      end_time,
      notes,
      ptoOpen,
    } = this.state;

    const { startKey, endKey } = this;

    const hasTicketNumber = !!ticket_number;
    const hasEquipment = !!equipment;

    let isPtoSelected = false;
    if (pto_type !== 'none') {
      isPtoSelected = true;
    }

    const ptoDisabled = (hasTicketNumber || hasEquipment);
    const ticketNumberDisabled = isPtoSelected || hasEquipment;
    const equipmentDisabled = isPtoSelected || hasTicketNumber;

    /* NOTE: Either one of the 3 types of work is selected, or none (shop work) is selected */
    const allowSubmit = ((!isPtoSelected && !hasTicketNumber && !hasEquipment)
      || (isPtoSelected || hasTicketNumber || hasEquipment))
      && start_time && end_time;

    return (
      <form>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <ControlLabel>
                PTO Type
              </ControlLabel>
              <DropdownList
                name="pto_type"
                disabled={ptoDisabled}
                open={ptoOpen}
                onFocus={this.handlePTOOnFocus}
                onToggle={this.handlePTOOnToggle}
                onMouseDown={(e) => { e.preventDefault(); }}
                data={PTO_TYPES}
                value={pto_type}
                onChange={this.handlePTOChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <ControlLabel>Ticket</ControlLabel>
              <TicketInput
                assigned="attachable"
                disabled={ticketNumberDisabled}
                name="ticket_number"
                value={ticket_number}
                onChange={this.handleValueChange}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <ControlLabel>Equipment</ControlLabel>
              <EquipmentInput
                disabled={equipmentDisabled}
                name="equipment"
                value={equipment}
                onChange={this.handleValueChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            {/* NOTE: Turn guide off to no have symbols in input after creating time entry */}
            <FormGroup>
              <ControlLabel>Start Time</ControlLabel>
              <FormControl
                key={startKey}
                componentClass={MaskedInput}
                name="start_time"
                value={start_time}
                onChange={this.handleValueChange}
                type="text"
                placeholder="HH:mm"
                guide
                mask={[/\d/, /\d/, ':', /\d/, /\d/]}
                pipe={createAutoCorrectedDatePipe('HH MM')}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <ControlLabel>End Time</ControlLabel>
              <FormControl
                key={endKey}
                componentClass={MaskedInput}
                name="end_time"
                value={end_time}
                onChange={this.handleValueChange}
                type="text"
                placeholder="HH:mm"
                guide
                mask={[/\d/, /\d/, ':', /\d/, /\d/]}
                pipe={createAutoCorrectedDatePipe('HH MM')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>Notes</ControlLabel>
              <FormControl
                name="notes"
                value={notes}
                onChange={this.handleValueChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <ButtonToolbar className="pull-right">
              <Button bsStyle="warning" name="cancel" onClick={this.handleCancel}>
                Cancel
              </Button>
              {!key
              && (
              <Button
                bsStyle="primary"
                disabled={!allowSubmit}
                name="create"
                onClick={this.handleCreate}
              >
                Create
              </Button>
              )}
              {!!key
              && (
              <Button
                bsStyle="primary"
                disabled={!allowSubmit}
                name="update"
                onClick={this.handleUpdate}
              >
                Update
              </Button>
              )}
            </ButtonToolbar>
          </Col>
        </Row>
      </form>
    );
  }
}

TimeEntryEditor.fragments = {
  crewEditor: gql`
    fragment TimeEntryEditor on TimeEntryForm {
      key
      pto_type
      equipment {
        id
        equipment_number
      }
      ticket_number {
        id
        number
      }
      date
      start_time
      end_time
      notes
    }
  `,
  userEditor: gql`
    fragment TimeEntryUserEditor on TimeEntry {
      key
      pto_type
      equipment {
        id
        equipment_number
      }
      ticket_number {
        id
        number
      }
      date
      start_time
      end_time
      notes
    }
  `,
};

TimeEntryEditor.propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  item: propType(TimeEntryEditor.fragments.crewEditor),
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,

  date: PropTypes.string.isRequired,

  timezone: PropTypes.string,
});

TimeEntryEditor.defaultProps = {
  item: null,
  timezone: 'America/Chicago',
};

export default TimeEntryEditor;
